export const INITIATE = '[SKILLSET] INITIATE';
export const GET_USER_SKILLS_BY_USER_ID = '[SKILLSET] GET_USER_SKILLS_BY_USER_ID';
export const UPDATE_USERS_SKILLS = '[SKILLSET] UPDATE_USERS_SKILLS';